export interface MenuItem {
  id: string
  titleTranslations: Record<ServiceTitleLanguages, string>
  iconTemplate: string
  serviceUrl: string
  notificationCount: number | undefined
  clickHandler: ((e: MouseEvent) => boolean) | undefined
  permissions: UserRole[]
  children?: MenuItem[]
}

export type MenuItemExtended = MenuItem & {
  title: string
  isActive: () => boolean
  children?: MenuItemExtended[]
}

export interface ServiceUrls {
  [environment: string]: {
    [service: string]: string
  }
}

export interface SideNavItemOptions {
  notificationCount: number
}

export interface SideNavOptions {
  [id: string]: SideNavItemOptions
}

export enum UserRole {
  CF_MANAGER = 'OTTO-CONTENT-FACTORY-CF-MANAGER',
  CF_REQUESTER = 'OTTO-CONTENT-FACTORY-CF-REQUESTER',
  CF_SERVICE_PROVIDER = 'OTTO-CONTENT-FACTORY-CF-SERVICE-PROVIDER',
}

export type ServiceTitleLanguages = 'en' | 'de'
export interface SERVICE_INFO {
  id: string
  titleTranslations: Record<ServiceTitleLanguages, string>
  icon: string
  children?: SERVICE_INFO[]
}
